<template>
  <div class="wrap">
    <h3 class="title">我是队长用户服务协议</h3>
    <p>本平台—“我是队长”是北京海科融通支付服务有限公司（以下简称“本公司”）负责运营的，向用户（即代理人，以下简称“您”或“用户”）提供代理人拓展本公司提供银行卡收单服务的特约商户的相关支持服务的互联网平台，该平台的形式包括但不限于APP、网站,以下简称“平台”。</p>
    <p>为了保障您的权益，请于注册或使用本服务前，仔细阅读并完全理解本服务条款的全部内容，其中用粗字体予以标注的，是与您的权益有或可能具有重大关系，及对本公司具有或可能具有免责或限制责任的条款，请您特别注意。您必须在不加修改地无条件地完全接受本服务协议所包含的条款、条件和本平台已经发布的或将来可能发布的各类规则，并且遵守有关互联网及/或本平台的相关法律、规定（以下提及“法律、法规”包括但不限于法律、法规、政府规章及其他应遵守的规范性文件）与规则的前提下，才能进入用户注册程序。您只有成功注册成为本平台用户后，才能使用本平台提供的用户服务。如您不同意本服务条款的任何内容，请勿注册或使用本平台提供的用户服务。您认可，注册为平台用户后需经过实名认证及银行卡鉴权通过后才享有使用本平台服务的权利。</p>
    <p>第一条 用户的主体资格</p>
    <p>1、本平台只接受持有有效身份证件的18周岁以上的具有完全民事行为能力的自然人或具有合法运营资格的机构成为平台用户。如您不具备上述资格，您应立即停止在本平台的注册程序、停止使用本平台服务；同时，本平台有权随时终止您的注册进程及服务、注销您的账户（本协议提及的“注销账户”、“取消用户资格”“终止服务”等词语包含终止本协议及相关网签协议的涵义），您应对您的注册给本平台带来的损失承担赔偿责任，如您为限制民事行为能力或无民事行为能力的自然人，您的监护人应承担相关责任。</p>
    <p>2、在注册时和使用本平台服务的所有期间，您应提供您自身的真实、最新、有效及完整的信息资料并保证提交的所有资料和信息（包括但不限于身份证信息、电子邮件地址、联系电话、联系地址、账户与财务信息）在上述期间具有有效性及安全性，否则本平台有权拒绝您的注册申请或终止服务，如造成本平台或其他第三方损失的，您应当承担赔偿责任。</p>
    <p>第二条 服务内容</p>
    <p>1、本平台专注于竭诚为您提供您（代理人）拓展特约商户的支持服务。您成功注册成为用户后，可通过您设置的用户名和密码登录本平台，您可在平台进行商户入网、银行卡收单服务所使用的终端机具的提取、收取分润、相关信息的查询等服务，具体以本平台公布的服务内容为准。</p>
    <p>2、您作为发展本公司银行卡收单业务的代理人，您承诺不得与特约商户进行超出本公司指定范围的约定，包括但不限于擅自发展下线代理人、向下级代理人收取入会费、修改特约商户可享受本公司的银行卡收单服务、向特约商户做未经授权的承诺与限制、向特约商户收费的行为。</p>
    <p>第三条 使用须知</p>
    <p>1、您不得利用本平台从事任何违反中国法律、法规或侵犯他人权益的活动；不得发送、公布或展示违反中国法律、法规及本协议的内容，任何垃圾、广告推销内容。本平台在发现您从事该等活动时，有权不经通知而立即停止您对本平台的全部或部分功能的使用，删除上述内容，注销您的账户并不予任何赔偿，同时无需向您支付分润。</p>
    <p>2、您在注册时向本平台提交的手机号码、电子邮箱、用户名、密码及安全问题答案等是您在本平台的识别信息。您注册成功后应妥善保管上述识别信息，不得将其转让或授权第三方使用，如果本平台发现同一账户和密码在同一时间内被多人同时登陆使用，本平台有权限制该用户访问直至取消用户资格，并不予任何赔偿，不予支付任何的分润。同时，您确认，使用您的用户名和密码登录本平台后在本平台的一切行为均视为代表您本人意志并由您承担相应的法律后果。</p>
    <p>3、若您发现有他人冒用或盗用您的用户名及密码或任何其他未经合法授权之信息登录时，应立即以有效方式通知本平台，要求暂停相关服务。同时，您理解本平台对您的请求采取行动需要合理期限，而在本平台采取实际行动之前，您应承担任何未经授权人士使用此服务或此服务被用作未经授权用途的不利后果并对其负责，本平台对已执行的指令及所导致的您及任何第三方的损失不承担任何责任。</p>
    <p>4、您保证合法使用本平台提供的服务，未经本平台事先书面授权，不使用任何非法手段擅自进入本平台未公开的系统。</p>
    <p>5、在您使用本平台时，您认可本平台或本平台委托的第三方可以通过短信、电子邮件、微信等电子形式向您发送关于本平台或者其他方的广告，或者在任何形式的通知中附带广告或者含有广告的链接。</p>
    <p>第四条 用户的授权以及用户信息的保护与披露</p>
    <p>1、您同意本平台在业务运营中收集和储存您的用户信息，包括但不限于您自行提供的，本平台在您使用过程中自行收集取得的，以及向第三方收集的信息。本平台收集和储存您的用户信息的目的在于更好地为您及特约商户提供服务以及保障各方的合法权益。</p>
    <p>2、您同意本平台在业务运营中使用您的用户信息，包括但不限于(1)进行用户身份信息核实；（2）出于提供服务需要在本平台公示您的相关信息；(3)向本平台的合作机构提供您的用户信息；(4)由人工或自动程序对您信息进行评估、分类、研究；(5)使用您提供的联系方式与您联络并向您传递有关业务和管理方面的信息；（6）用于配合有权机关（包括但不限于人民银行、清算机构、发卡行、行业自律组织）依职权调取证据材料；（7）用户向中国人民银行个人信用信息基础数据库、其它依法设立的征信机构、以及有关法律法规或规章允许的其他机构等报送用户信用信息（含不良信息）。</p>
    <p>3、您授权本平台在为您业务办理的过程中自行或为您委托银行、第三方支付机构或其他有权机构提供代收、代付、实名认证、鉴权等支付相关服务。您同意本平台将您的分润款项自行或通过第三方在合理的时间内支付至您的结算账户。</p>
    <p>4、授权效力</p>
    <p>您承诺本协议第四条的效力具有独立性，不因任何合同的任何条款的无效而失效。</p>
    <p>第五条 用户承诺和保证</p>
    <p>1、本平台用户应保证严格遵守中国现行法律、法规、政府规章及其他应该遵守的规范性文件，不在本平台从事危害国家安全、洗钱、套现、洗钱、传销等任何违法活动或者其他有违社会公共利益或公共道德的行为。</p>
    <p>2、您承诺在使用本平台或开展业务过程中，严格按照本公司的有关规定和要求，每月对入网特约商户的履约情况和业务动态进行监督和检查，如发现特约商户的业务有违反国家法律、法规规定或本协议约定的，应及时向本公司履行告知义务的同时立即协助本公司暂停违规特约商户的支付服务，并应本公司要求配合处理相关事宜。</p>
    <p>3、风险承担</p>
    <p>3.1特约商户违法、违约、违规风险：您认可，基于特约商户的违法、违反入网本公司时签署的《特约商户受理银行卡业务服务协议》及其相关法律文件的，本公司会根据情况中止、终止与您的合作，并不支付相应的分润。</p>
    <p>3.2个人信息滥用风险：因您的个人信息和资料被不法分子窃取、泄露的风险以及由此带来的个人隐私、生活受到干扰、侵犯的风险；</p>
    <p>3.3服务中断风险：由于互联网相关服务具有特殊性，因本平台、相关第三方的设备系统维护、设备故障、电力中断、网络故障及其他公司不可控制情况的影响，可能导致服务中断；</p>
    <p>3.3不可抗力风险：地震、台风、水灾、海啸、雷电、火灾、瘟疫、流行病、战争、恐怖主义、敌对行为、暴动、罢工、交通中断、停止供应主要服务、电力中断、经济形势严重恶化或其它类似事件导致的风险；系统故障或缺陷、病毒、设备故障、通讯故障、网络故障或中断、电力故障、网络故障、黑客攻击、计算机病毒攻击以及其它因素可能导致本平台出现非正常运行或者瘫痪。</p>
    <p>3.4操作风险</p>
    <p>如果您缺乏必要的互联网经验，可能出现因操作不当导致资金交易失败或失误；如果您未能谨慎保管自己的账号和密码，或者设置的密码简单导致密码被破解，以及您在进行资金交易时未能确保所使用的操作终端、网络以及周围环境的安全性，导致账号和密码被他人盗取、使用，可能导致违反您本人意愿的资金交易以及资金损失。由于本平台以账号和密码进行身份识别，一切以您认证方式进行的操作等均被视为您本人的操作，您将对此发生的一切后果承担全部责任。</p>
    <p>3.5其他风险。</p>
    <p>第六条 免责声明</p>
    <p>1、除非另有书面协议约定，本平台在任何情况下，对用户使用本平台服务而产生的任何形式的直接或间接损失均不承担法律责任，包括但不限于资金损失、收益损失等。</p>
    <p>2、本平台作为银行卡收单机构，针对您拓展行为的合法性、商户交易本身的问题而导致的任何纠纷均不承担任何责任。</p>
    <p>3、任何本平台之外的第三方机构或个人所提供的服务，其服务品质及内容、纠纷由该第三方自行、独立负责，与本平台无关。</p>
    <p>第七条 网签协议的效力及有效期</p>
    <p>1、用户一旦点击确认或同意了本平台所有的协议、声明、承诺等法律文件即“网签协议”，即代表该文件即刻生效。由于平台产品流程可能出现网签协议部分内容还未确认，确认后以通知或更新网签协议的形式发送给用户，用户在此承诺不会以未阅读未或知晓该内容作任何形式的抗辩，也不得以未签署书面协议为由否认协议的效力，如果用户对网签协议内容有任何异议请在收到该通知或网签协议后立即通知本平台，经平台同意停止使用该产品，如未通知本平台并停止使用该产品，视为认可该网签协议的效力，后期不会以此为由否认其效力。</p>
    <p>2、本协议的有效期为自本协议签署之日至网签协议履行完毕，全部义务履行完毕时，且平台账户注销之日止。</p>
    <p>第八条 用户注销、暂停、终止或限制访问</p>
    <p>1、如您一年内无用户账户操作且用户账户无余额，您的用户账户进入为期一年的休眠期，休眠期结束后用户账户自动注销。休眠期内用户账户有任何操作或入账，用户账户正常使用。</p>
    <p>2、如果您决定不再使用本平台服务时，应首先完成所有服务义务，再将您的用户账户下所对应的可用款项（如有）全部提现，保证与特约商户、相关方无任何争议以及遗留问题，并向本平台申请注销该账户，经本平台审核同意后方可正式注销您的账户。</p>
    <p>3、本平台有权基于单方独立判断，在认为可能发生危害交易安全等风险情形时，不经通知而先行暂停、中断或终止向您提供本协议项下的全部或部分用户服务，并将注册资料移除或删除，且无需对您或任何第三方承担任何责任。</p>
    <p>4、只要您利用本平台从事违法活动或者违反本协议、其他网签协议的约定，本平台可在不发出任何通知的情况下立即使您的账户无效，或撤销您的账户以及您的账户内的所有相关资料和档案，直接终止本协议。账号终止后，本平台没有义务为您保留原账号中任何信息，或转发任何未曾阅读或发送的信息给您或第三方。此外，本平台亦不会就终止您的账户使用而对您或任何第三者承担任何责任。</p>
    <p>5、您的账户的暂停、中断或终止不代表用户责任的终止，用户仍应对其使用本平台提供服务期间的行为承担后续义务及可能的违约或损害赔偿责任，同时本平台有权永久存储用户的相关信息。</p>
    <p>第九条 知识产权保护</p>
    <p>本平台所有内容和服务，包括但不限于平台的整体结构、网页设计、文字、图片、图表、软件、视频文件、音频文件、源代码、广告以及本平台为用户提供的其它信息或资料，其知识产权属本平台所有。未经本平台书面许可，任何人不得为了任何目的进行复制或者以其它方式进行非法使用。</p>
    <p>第十条 赔偿</p>
    <p>1、用户因违反本协议或其他网签协议，或违反了任何法律、法规的规定，给本平台造成损失的，应予赔偿，赔偿范围包括但不限于本平台的直接损失、间接损失以及维权费用（“维权费用”包括但不限于律师费、取证费、交通费、住所费）等。</p>
    <p>2、用户因违反前款规定而侵害了第三方的权利，导致本平台遭受任何第三方提起的索赔、诉讼或行政责任，用户承诺无条件承担相应责任并使本平台免责。若因此给本平台造成损失的，应予赔偿，赔偿范围包括但不限于本平台的维权费用、名誉损失以及本平台向第三方支付的赔偿金、行政罚金等。</p>
    <p>第十一条 保密条款</p>
    <p>1、对于本平台用户在接受本平台提供服务过程中了解到的本公司的所有信息，包括但不限于本平台信息资料、业务运营情况、商业秘密等，不得向任何第三人披露，保密期限为永久。</p>
    <p>2、除本协议另有约定外，本平台须根据中国法律、法规的规定对本平台用户的个人信息、资产情况和相关资料予以保密。</p>
    <p>第十二条 税费缴纳</p>
    <p>您有在使用本平台的过程中产生的相关税收的缴纳义务，平台有权根据中国法律规定为您代扣代缴或由您自行向相关主管税务机关申报、缴纳。</p>
    <p>第十三条 送达与信息变更</p>
    <p>1、您认可您提供给平台的个人信息即为有效的送达方式及送达地址，送达内容包括但不限于平台的通知、公函、权力机关的文书等；送达方式包括但不限于站内信、短信、邮寄等，一经发出视为送达。</p>
    <p>2、用户如变更本协议第一条第2款提及的相关信息，须及时通知本平台，否则仍视为有效的送达地址。因您未及时通知而导致自身、本平台及第三方受到的一切损失，由您自行承担，如因此给本平台造成损失的，本平台有权向您追偿。</p>
    <p>第十四条 继承或赠与</p>
    <p>如果您欲将您的债权赠与、转让、或发生继承事实，必须由主张权利的受赠人、受让方或继承人向本平台出示经公证机关公证的赠与、转让或继承的权利归属证明文件或其他相关证明，经本平台同意后方可予以协助办理权属变更手续，由此产生的相关税费，由主张权利的受赠人、受让方、继承人依法向相关主管税务机关申报、缴纳，本平台不负责相关事宜的处理。</p>
    <p>第十五条 争议的处理</p>
    <p>本协议在履行过程中，如发生任何争执或纠纷，双方应友好协商解决，协商不成的，任何一方有权向合同履行地北京市海淀区人民法院提起诉讼解决。</p>
    <p>第十六条 其他</p>
    <p>1、本协议中的任何条款或部分条款因违反中国法律而无效的，不影响本协议其他条款的效力。</p>
    <p>2、您同意本平台因为与您的合作变更、服务项目变更、业务变更或法律法规、监管要求、国家政策变更等原因修改本协议以及平台所有网签协议等，修改将以平台公告、短信通知、站内信等形式进行，协议修改后您可以根据个人意愿选择是否同意，如不同意应停止使用本平台，否则视为同意修改。如因业务模式的限制，导致无法提前终止使用本平台的，您同意届时认可上述协议的修改并履行完毕相应义务。</p>
    <p>3、您作为本平台的用户，有义务随时关注本平台公示信息、通知、站内信、网签协议等，上述内容一经刊登、发送即生效，您不得以未阅读、未收到或未确认与签署为由否认其效力。</p>
    <p>4、如有关内容其他网签协议未约定，适用本协议约定的相关内容。</p>
    <p>支付业务合作协议</p>
    <p>本协议是我是队长（“以下简称“本平台”）所有者北京海科融通支付服务股份有限公司（以下简称“本公司”）与我是队长注册用户(以下简称“您”或“用户”）拓展服务就特约商户拓展、商户服务等相关事宜协商一致，达成的协议。</p>
    <p>为了保障您的权益，请于注册或使用本服务前，仔细阅读并完全理解本服务条款的全部内容，其中用粗字体予以标注的，是与您的权益有或可能具有重大关系，及对本公司具有或可能具有免责或限制责任的条款，请您特别注意。</p>
    <p>第一条、术语定义</p>
    <p>1、支付服务：指本公司依据《非金融机构支付服务管理办法》、《银行卡收单业务管理办法》等相关法律法规在收付款人之间作为中介机构提供的货币资金转移的相关服务。</p>
    <p>2、银行卡收单拓展服务：指除特约商户资质审核、受理协议签订、收单业务交易处理、资金结算、风险监测、受理终端（或称“POS”机具）主密钥生成和管理、差错和争议处理业务以外的服务内容，主要包括特约商户推荐、受理终端布放与受理标识张贴、特约商户培训、受理终端维护、耗材配送、特约商户调单等。</p>
    <p>3、受理终端：是指通过读取或输入银行卡相关信息，发起交易并提示操作完成的读取或输入银行卡相关信息，发起交易并提示操作方完成的专用设备及终端程序。</p>
    <p>4、特约商户（或称“商户”）：指与本公司签订《特约商户受理银行卡业务服务协议》，按约定受理银行卡并委托本公司为其完成交易资金结算的企事业单位、个体工商户或其他组织，以及按照国家工商行政管理机关有关规定，开展商品交易等经营活动的自然人。</p>
    <p>第二条、业务授权</p>
    <p>1、本协议生效后，本公司授权您在___________行政区域范围内开展银行卡收单拓展服务。如您超范围开展服务，本公司有权拒绝分润，并视情节从分润中扣除相应违约金甚至单方面解除协议。</p>
    <p>2、您接受本公司相关管理办法和操作规范的内容，并承担作为本公司授权合作方开展业务所应承担的责任。</p>
    <p>3、本协议之授权，为非独占、且不可转让的权利。</p>
    <p>4、您认可本协议的成立不代表您与本公司形成了委托拓展服务之外的法律关系，包括但不限于劳动关系、劳务关系。您使用本平台服务过程中，本公司并不限制您的工作时间、您并不适用我公司内部员工适用的各项规章制度，本公司向您支付的费用为您为本公司进行拓展特约商户所应向您支付的分润，而不是工资、劳务报酬等。本公司无义务为您缴纳社会保险和公积金，同时您将不以劳动者、劳务人员的身份向本公司主张任何基于劳动关系、劳务关系的诉求。</p>
    <p>第三条、本公司的权利与义务</p>
    <p>1、本公司作为特约商户的签约方，有权对您推荐的特约商户进行审核，自行决定是否签约。</p>
    <p>2、本公司有权根据人民银行、中国银联、中国支付清算协会及国际组织（以下简称“监管机构”）相关业务规范对您在商户拓展、人员培训、信息安全、问题处理等方面提出相关管理办法与技术规范，您应严格遵守并执行。</p>
    <p>3、本公司负责特约商户的资金清算、风险监测、受理终端秘钥生成和管理、账务核算处理、错账查询和调整、争议处理等工作。并对您落实非主密钥管理、网络安全、系统安全、机房安全等各项业务与技术安全进行监督。</p>
    <p>4、对于您采购、安装、拆除、维护、管理、保养、配送的POS终端，由您承担全部费用。本公司有权按照监管机构的标准，确定POS终端品牌、型号和应用程序是否适用并拒绝不适用的受理终端并要求您更换。</p>
    <p>5、本公司只为您拓展的入网特约商户提供支付结算服务，不介入因商户交易本身的问题而导致的任何纠纷，也不对此承担任何责任。</p>
    <p>6、本公司发现特约商户有下列行为之一的，本公司有权中止或终止您的拓展服务，解除本协议，可以立即关闭商户的交易功能，停止资金结算服务并不向您支付相应的分润并要求您赔偿损失；</p>
    <p>1）参与洗钱、诈骗、恐怖融资、套现、网上赌博等违法犯罪活动的，或者套用MCC码，从事非法经营、不正当竞争、虚假宣传、非法广告、商业欺诈、侵害消费者与用户合法权益的任何活动；</p>
    <p>2）无正当理由拒绝受理用户使用本公司支付服务进行交易，或商户同时选择其他收单机构进行银行卡收单服务的；</p>
    <p>3）将本公司提供的支付服务用于约定用途之外的，包括但不限于提供给任何第三方使用、随意挪用至非约定的营业地点、将其他商户交易假冒本商户交易，无真实商品标的或服务标的的交易；</p>
    <p>4）故意诋毁或损害本公司声誉或存在可能诋毁或损害本公司声誉之行为的；</p>
    <p>5）违反本公司银行卡收单服务规则的，包括但不限于受理有损坏或涂改、卡背面的签名栏无签名的银行卡的；</p>
    <p>6）以不正当手段和方式存储、采集、截取、盗用用户的银行卡卡号、密码等信息的；</p>
    <p>7）持卡人使用银行卡进行正常交易而向其收取额外的费用，转嫁或者变相转嫁刷卡佣金或者以此为理由降低持卡人当期的优惠折扣服务，或者以其他优惠措施和理由引导持卡人使用非银行卡的方式进行结算；</p>
    <p>8）根据法律、法规或政策的要求不应或不能继续提供支付服务的；</p>
    <p>9）您违反本协议相关约定或者本公司认为需要处理的。</p>
    <p>第四条、您的权利与义务</p>
    <p>1、您承诺遵守相关法律、行政法规、国家管理部门出台的行业规章及市场规则，遵守本公司相关制度规定。不得损害国家利益、社会公共利益、持卡人、发卡机构和银行卡清算机构的合法权益。</p>
    <p>2、您必须对服务系统支持的商户履行以下监察义务：</p>
    <p>1）定期向本公司通报银行卡收单服务的有关事项；</p>
    <p>2）及时向本公司通报银行卡收单服务的突发性事件；</p>
    <p>3）配合本公司接受监管机构的检查；</p>
    <p>3、您在开展业务过程中，应正确表明身份，不得做混淆表示，并保证不对本公司做任何负面宣传。您有义务如实向特约商户解释您与本公司的合作关系、产品与服务内容等。如因您不实宣传与引导导致商户误解、或给本公司带来不利影响的，您负责消除影响并赔偿商户与本公司的损失。</p>
    <p>4、您在开展业务过程中，应严格按照本公司的有关规定和要求，每月对入网特约商户的履约情况和业务动态进行监督和检查，如发现入驻特约商户的业务有违反国家法律、法规规定或本协议约定的，应在及时向本公司履行告知义务的同时立即暂停违规特约商户的支付服务，并应本公司要求配合处理相关事宜。同时，您对于已撤销服务的特约商户的终端设备必须及时收缴。</p>
    <p>5、如特约商户发生重大业务事件（如发生篡改、泄漏和破坏账户信息与交易数据，大范围病毒感染，网络被攻击等）或业务变更（如公司重组、法人变更、管理人员变更、业务变更、开展新业务品种等），您应在24小时内通知本公司并配合本公司向事件发生地人民银行中心支行进行上报；对须采取应急方案的，您应及时报告处理情况和整改措施。您发现涉嫌银行卡违法犯罪案件或重大风险事件的，应当于24小时内报送本公司各地分公司，同时报送本公司总公司，并配合本公司向事件发生地人民银行中心支行进行上报。</p>
    <p>6、本协议解除后您有义务协助本公司办理商户交接工作，在不影响特约商户正常交易的情况下，将特约商户向本公司或本公司指定的第三方进行交接。如果您拒绝交接或交接不符合合同约定造成本公司损失的的应当承担赔偿责任。</p>
    <p>7、在本协议有效期内，您不得从事任何与本公司支付业务有竞争关系的第三方产品或服务的经营并不得向本公司的商户进行二次营销，否则视为您违约，本公司有权因此而终止本协议全部或任意条款的执行，并保留向您追诉和要求赔偿的权利。</p>
    <p>8、您不得承担或变相实质承担以下收单核心业务：</p>
    <p>1）特约商户审批和签约；</p>
    <p>2）特约商户档案和信息管理，含特约商户信息系统的运行和维护；</p>
    <p>3）收单交易处理，含收单交易处理系统的运行和维护；</p>
    <p>4）为特约商户受理银行卡交易进行资金结算；</p>
    <p>5）收单业务差错和争议处理；</p>
    <p>6）收单交易监测、风险控管和处理，含收单交易监测系统和相关风险控管系统的运行和维护；</p>
    <p>7）受理终端主密钥生成及其管理；</p>
    <p>8）存储银行卡密码、有效期、卡片验证码等交易验证信息；</p>
    <p>9）自主设置交易路由或加载未经本公司同意的程序；</p>
    <p>10）以大商户名义接入并下挂多个二级商户；</p>
    <p>11）自行编制、篡改、仿冒或重组交易报文。</p>
    <p>9、您不得对终端进行包括但不限于私自拆卸、测绘等行为。</p>
    <p>10、您在开展本公司业务时，有义务按照《中华人民共和国反洗钱法》等相关法律法规的规定，履行特约商户身份识别等反洗钱义务。您应采取特约商户身份识别和身份资料保存的必要措施，妥善保管特约商户身份资料，保证本公司在办理业务时，能立即获得您提供的特约商户身份基本信息，必要时获取特约商户有效身份证件的复印件或者影印件。</p>
    <p>11、若您存在下列情形之一的，本公司有权中止或终止您的拓展服务，解除本协议，将相关特约商户关停与暂停结算（如需）等措施，不向您支付相应的分润并要求您赔偿损失：</p>
    <p>1）您进行不当宣传，影响本公司声誉的；</p>
    <p>2）您未按照本公司的规定擅自发展下线代理人、向下级代理人收取入会费，或未按商户拓展行业要求拓展特约商户的；</p>
    <p>3）您未认真履行特约商户调查职责，涉嫌套现、移机、套用MMC码、二次分账等违规特约商户数量占总特约商户数量2%以上的；</p>
    <p>4）您未认真履行特约商户调查职责，涉嫌套现、移机、套用MMC码、二次分账等违规特约商户交易总量占特约商户总交易量1%以上的；</p>
    <p>5）您未按照本公司要求对特约商户进行收单业务培训或日常运营服务，导致投诉或发生风险交易的；</p>
    <p>6）您协助特约商户变造、伪造商户签约申请资料、调单资料的；</p>
    <p>7）有明确证据证明您协助特约商户进行违规交易的；</p>
    <p>8）在本协议生效后的三个月以后，您提交的特约商户申请退单率在15%以上的；</p>
    <p>9）您未按照本公司要求进行商户巡检的或您未配合本公司进行商户巡检的；</p>
    <p>10）在发生风险交易时，您未配合本公司进行特约商户调单和退款追索工作的；</p>
    <p>11）与不良商户勾结进行如虚假伪冒申请、伪卡盗刷、套现、洗钱、分单、虚假交易等活动；</p>
    <p>12）以套用、变造与真实商户类型不相符商户编码等各类收单变相降低刷卡手续费率，恶意争抢客户；</p>
    <p>13）采取不正当竞争手段盗取、转移特约商户或受理终端；</p>
    <p>14）留存、窃取或泄露客户账号、身份证号码等敏感信息及交易信息；</p>
    <p>15）对商户的银行卡交易进行交易处理，自主设置交易路由、加载未经本公司同意的程序或改造已经本公司同意的程序，通过编制、篡改、仿冒或重组交易报文等方式隐匿、歪曲真实交易；</p>
    <p>16）将外包业务进行转包、转让；将特约商户结算资金通过其他机构进行二次清算；</p>
    <p>17）涉及诉讼、负面舆论或负面新闻；</p>
    <p>18）其他您违反本协议约定的行为或者本公司认为需要处理的行为。</p>
    <p>12、您应配合本公司接受监管机构的检查以及公安等有关部门的调查活动。</p>
    <p>第五条、POS机具的提供货</p>
    <p>1、您根据商户数量的预先评估，向本公司提取适量的POS机具，提货模式分为采购、免费、押金等，具体模式及费用根据本平台不时公布的在线合伙人我是队长拓展政策进行细化或更改，相关政策构成本协议的补充协议。</p>
    <p>2、本公司向您供应的产品的质量应当符合该产品的国家标准、行业标准，没有国家标准、行业标准的按照通常标准或符合协议目的的特定标准。</p>
    <p>3、您提取的机具必须接入本公司自身的第三方支付服务平台内。</p>
    <p>4、本协议生效后，您与本公司之间发生的传真提货、网上提货、口头提货、电话提货、合同提货等一切要求本公司提货的行为，均视为您向本公司发出的不可撤销之要约行为。若您发出提货指令后，在本公司发出货物前，欲变更提货内容的，必须经过本公司同意，否则应按约履行。（网上提货指本公司根据情况向您开通的电子商务系统，您可以通过计算机网络向本公司下单。经过本公司确认后，订单生效。）</p>
    <p>5、您向本公司提交的提货申请需要明确表述订购机具的名称、种类、数量、单价、您指定的收货地点、联系人等信息。</p>
    <p>6、本公司收到您的提货申请后，应及时付款（具体款项金额由本公司不定时发出的政策确定），本公司在您付款后15个工作日内，通过物流发送或本公司公司指定的人员为您发送、配送货物，如本公司因不可抗力、储备货物不足等原因，不能及时向您发送、配送货物，需及时的告知您。</p>
    <p>7、本公司向您发送货物时，如使用物流的方式，在发出货物后，将物流的相关信息及时的告知到您或您指定的收货人。货物一经物流发出即视为送达，您不得以任何理由主张本公司未发货，货物在途风险由您承担。</p>
    <p>8、POS机具的质保期为 年，超过质保期的机具如出现不能正常使用的情况，您须重新采购。</p>
    <p>第六条、考察期、检查与处罚</p>
    <p>1、本协议的初始期限（即____年___月____日至___年__月__日）为考察期。考察期间要求所有商户资料真实、交易活跃（即 ）、无风险交易,入网商户数不得少于____家、按照本协议约定履行义务等；考察期间如本公司认定您未能严格按照工作规范要求开展业务，本公司有权单方面终止合作。</p>
    <p>2、考察期间您所应收取的分润只统计不清算，考察期通过后十个工作日内本公司需将考察期内的分润全部清算给您；考察期结束考评未通过的，本公司将终止合作，考察期间所产生的分润本公司不予支付。</p>
    <p>3、本公司有权对您的业务开展情况、安全规章及服务质量进行检查。检查中发现违反本公司有关合作机构工作规范和市场规则等相关规定的，要求您限期整改，并将相关问题及其整改情况予于公布。</p>
    <p>4、本公司有权从以下方面对您的服务质量进行检查：包括但不限于投诉次数、终端可用率、商户培训效果、商户服务满意度、客户服务电话咨询率等。</p>
    <p>5、本公司有权从以下方面对您的安全质量指进行检查，包括但不限于检查中发现的安全隐患，您和您拓展的商户发生的安全事故等。</p>
    <p>6、本公司有权根据检查结果作出发函提示、警告并予通报、取消注册登记与授权并予通报、强制退出并通报等处罚措施。</p>
    <p>7、您受处罚后应当在发出提示或处罚通知10个工作日内以书面方式向您说明情况，制定并提交详细的整改措施。您受警告及以上处罚的，30天内不得为本公司提供服务。</p>
    <p>8、您理解并确认以下违规行为属于您的过失，本公司有权根据以下处理方式进行处罚。且本公司有权单方终止本协议，并要求您承担相应的赔偿责任。</p>
    <p>违规行为描述处理方式资质作假是指入网特约商户的各项资料，如身份证、业务员合影等图片存在作假的情况首次违规罚款500元；第二次违规罚款1000元；第三次违规罚款2000元，并停止入网一周。同时您需提交处理、改进方案违规入网是指通过本公司签约系统提交不符合入网规范与范围，并产生恶性行为的情况，包括通过本公司签约系统录入跨区商户、资质不符商户导致发生了伪卡交易等首次违规罚款500元；第二次违规罚款1000元；第三次违规罚款2000元，停止本公司签约系统自动审核功能一周，待您整顿完毕后重新申请开通消极补件是指对于您录入的商户，在通过系统自动审核后经复查检查需要进一步补充资质，您在规定的时间内未配合提供的情况取消本公司签约系统的自动审核功能，不符合入网条件商户直接关闭，待补件完成后由您申请开通拒绝商户协查是指对于本公司风控稽查中发现存在交易异常的商户，通知您进行实地协查后，您拒绝或消极配合的情况首次违规罚款500元；第二次违规罚款1000元；第三次违规罚款2000元，情节严重拒不配合的暂停入网</p>
    <p>9、您存在下列情形的，本公司有权单方面解除本协议，不向您支付相应的分润，并从分润中扣除人民币20000元/户（次）的罚金，不足以弥补本公司损失的，本公司有权追偿。</p>
    <p>1）冒用本公司名义开展业务活动；</p>
    <p>2）向其他机构转让、转包业务；</p>
    <p>3）推荐非真实、违规经营的商户或协助商户以虚假材料申请入网；</p>
    <p>4）存储客户银行卡密码、有效期、卡片验证码、磁道或芯片信息等敏感信息；</p>
    <p>5）自主设置交易路由、加载未经本公司同意的程序，改造已经本公司同意的程序；</p>
    <p>6）对推荐商户的银行卡交易通过编制、篡改、仿冒或重组交易报文等方式隐匿、歪曲真实交易；</p>
    <p>7）其他违反监管政策、行业自律规范及银行卡清算机构业务制度的行为。</p>
    <p>10、您存在下列情形的，本公司有权单方面解除本协议，不向您支付相应的分润，并从分润中扣除人民币50000元/户（次）的罚金，不足以弥补本公司损失的，本公司有权追偿。</p>
    <p>1）因商户发生风险交易（包括但不限于洗钱、诈骗、从事受理伪卡/盗卡服务、虚假申请、侧录、泄露账户及交易信息、套现、洗单、分单、篡改订单金额、恶意倒闭、虚假交易、超范围使用授权限额；因商户违反操作规范或其他相关规定发生持卡人否认交易的，应配合完成调单、纠纷调查等措施），给本公司或持卡人造成损失的；</p>
    <p>2）严重违反银联卡业务规章、银联卡账户及交易数据安全管理规则、市场规则及本公司管理办法、本协议约定等。</p>
    <p>第七条、分润与结算</p>
    <p>1、进行银行卡收单拓展服务所需支出的费用由您自行承担，本平台按以下标准针对您提供的银行卡收单拓展服务向您支付业务分润，支付标准为：</p>
    <p>结算成本费率借记卡结算成本费率： %，手续费封顶： 元贷记卡结算成本费率： %微信扫码结算成本费率： %；公众号结算成本费率： %；H5结算成本费率： %支付宝扫码结算成本费率： %；H5结算成本费率： %云闪付结算成本费率： %无卡快捷支付结算成本费率： %QQ钱包支付结算成本费率： %</p>
    <p>备注：</p>
    <p>计算公式：分润=（商户签约费率-结算成本费率）×交易额×分润比例</p>
    <p>商户签约费率，是指为特约商户提供交易资金结算服务收取的交易手续费率。</p>
    <p>交易额，是指由拓展的特约商户在合同期限内按照签约费率执行的交易量。</p>
    <p>2、结算周期</p>
    <p>您应在收到本公司的业务分润数据后的五个工作日内进行核对确认，如对分润数据持有异议，由本公司于您进行交易数据的对账处理，并以银行或银联对账的交易数据为准。核对无异议后，本公司五个工作日内向您支付相应分润。</p>
    <p>3、结算限额</p>
    <p>您的分润需累计至2000元人民币以上（含本数）时方给予结算；若不足2000元，则延期累计到下期结算。</p>
    <p>以上内容根据本平台不时公布的在线合伙人我是队长拓展政策进行细化或更改，相关政策构成本协议的补充协议。</p>
    <p>第八条、违约责任</p>
    <p>1、您与本公司均同意，本协议之任何一方违反各自在本协议及相关附件中所作的保证、承诺或其他条款，均构成违约，如因一方的违约行为对另一方造成损失的，违约方应负赔偿责任。</p>
    <p>2、由于不可抗力或意外事件而影响本公司正常的服务和技术支持时，不视作本公司违约，您对此表示认同。（本协议所称不可抗力、意外事件是指不能预见、不能克服并不能避免且对一方或双方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为、管制以及其他如电信线路故障、银行系统调整或故障、突然停电等意外事件等。）</p>
    <p>第九条、保密条款与知识产权</p>
    <p>1、您与本公司对对方的保密信息均负有保密义务。</p>
    <p>2、您应对基于本协议所获得的本公司技术信息、银行卡收单业务信息、代理商运营信息、客户资料、管理制度、财务信息、管理信息等进行保密，未经本公司书面许可，在本协议存续期间和其后的任何时候，不得用于履行本合同以外的用途，或提供给第三方、公开等。</p>
    <p>3、您与本公司各自所有的知识产权均归各自所有；未经本公司书面许可，您不得以任何方式、在任何场所使用本公司以及银联的logo、名称、商标等。</p>
    <p>4、保密信息不包括：①在一方传递给对方时已被公众合法掌握的信息或材料；②在一方传递给对方时已被对方通过合法途径依法掌握的信息或材料，且并不负有任何保密义务。</p>
    <p>5、本协议项下的保密义务不因本协议的无效、提前终止、解除而失效。</p>
    <p>第十条、协议变更和解除</p>
    <p>1、订立本协议所依据的法律、法规、行政规章发生变化，本协议应变更相关内容；订立本协议所依据的客观情况发生重大变化，致使本协议无法履行的，经您与本公司双方协商同意，可以变更或者终止协议的履行。</p>
    <p>2、在协议执行期间，如果您与本公司或任一方认为需要终止，应提前15日通知对方，经协商一致同意解除协议的，您与本公司在财务结算完毕、各自责任明确履行之后，方可终止协议。因一方违反本协议的约定擅自终止本协议，给对方造成损失的，应赔偿对方损失。</p>
    <p>3、一方未履行或违反依据本协议所应承担的义务，经另一方给予一定期限仍不履行义务或不予采取补救措施，致使另一方依据本协议的预期利益无法实现或协议继续履行没有必要，另一方有权解除本协议。</p>
    <p>4、如您在开展业务过程中违反本协议任何约定及附件的任何规定，本公司有权随时通知您中止或终止合作。本协议于本公司终止合作通知发出之日终止。</p>
    <p>第十一条、其它</p>
    <p>1、本协议的内容或根据本平台不时公布的在线合伙人我是队长拓展政策进行细化或更改，相关政策构成本协议的补充协议，补充协议与本协议不一致的，以补充协议为准。</p>
    <p>2、本协议的有效期为自是本协议签署之日起一年。本协议到期前一个月内双方均未书面提出终止要求，则本协议自动顺延壹年，顺延次数不限。</p>
    <p>3、在履行本协议过程中发生的任何争议，应首先由您与本公司友好协商解决；协商不成的，任何一方均可向北京市海淀区人民法院诉讼解决。</p>
    <p>4、本协议中的任何条款或部分条款因违反中国法律法规、监管政策而无效的，不影响本协议其他条款的效力。如有关内容其他网签协议未约定，适用本协议约定的相关内容。</p>
    <p>5、您同意本平台因为与您的合作变更、服务项目变更、业务变更或法律法规变更等原因修改本协议以及平台所有网签协议、声明等，修改将以平台公告、短信通知、站内信等形式进行，协议修改后您可以根据个人意愿选择是否同意，如不同意应停止使用本平台，否则视为同意修改。如因服务项目的限制，导致无法使用本平台的，您同意届时认可上述协议的修改并履行完毕相应义务。</p>
    <p>6、您作为本平台的用户，有义务随时关注本平台公示信息、本平台通知、站内信、网签协议等，上述内容一经刊登、发送即生效，您不得以未阅读、未收到或未确认与签署为由否认其效力。</p>
    <p>个人信息使用授权书</p>
    <p>授权人，本人同意并不可撤销地授权北京海科融通支付服务股份有限公司以及其运营的在线合伙人我是队长平台（以下简称“平台”），在本次业务过程中（从业务申请至业务终止），基于约定用途(包括但不限于用户注册、依法或经有权部门要求的用途等)，享有下列权限：</p>
    <p>1、授权平台或平台委托的第三方采集本人的身份信息、通讯信息、账户与财务信息、可能对本人产生负面影响的不良信息等，以下简称个人信息；</p>
    <p>2、将个人信息用于“在线合伙人我是队长”平台的用户注册、代收付、实名认证、鉴权等使用；</p>
    <p>3、授权平台或通过第三方服务机构（包括但不限于中国人民银行征信中心等第三方权威征信机构及其他第三方数据机构等）对申请人提交的个人信息进行核实；通过平台或前述第三方服务机构采集、研究、存储、合理使用申请人的个人信息用于为申请人提供服务、进行管理；</p>
    <p>4、授权平台向第三方服务机构提供个人信息以判断、识别业务风险及提升自身服务质量；</p>
    <p>5、授权本平台及第三方对本人信息进行采集、提供、传输、处理、合理披露等方式进行合理使用，从而提升平台服务质量；</p>
    <p>6、反映授权人（即申请人）本人资产状况的信息和纳税、缴费等信息是反映授权人（即申请人）本人的信用或风险状况的重要信息，本人理解并同意北京海科融通支付服务股份有限公司向信息提供者收集并向第三方提供上述信息。</p>
    <p>7、授权本台向第三方提供授权人的不良信息，本协议的签署视同事先征得了授权人的同意。</p>
    <p>特别声明：申请人已被明确告知提供上述信息可能会给本人带来经济、声誉、信用评估结果等方面的不利后果，或者信息使用者可能基于本人的信用状况拒绝向其提供产品或服务等，本人明知且仍然自愿作出上述授权并承担由此带来的一切法律后果。</p>
    <p>授权人（即申请人）本人承诺本授权效力具有独立性，不因其他合同的任何条款无效而失效。</p>
    <p>本授权书为电子格式，自申请人勾选“同意”或其他类似确认的电子按钮后，自动生成并发生法律效力。</p>
    <p>本授权书的授权期限为自是授权人确认之日至授权人通过平台签订的全部网签协议的义务与责任履行完毕，且平台账户注销之日止。</p>
    <img src="../../assets/img/backPic.png" @click="back" class="pic" v-if="entryMode">
  </div>
</template>

<script>
export default {
    data() {
      return {
        entryMode: "" //判断是怎么进来的
      }
    },
    created () {
      document.title = "用户服务协议"
      let entryMode = this.$route.query.entryMode;//判断来源
      if(!!entryMode){
        this.entryMode = entryMode;
      }
    },
    methods: {
        back(){
            this.$router.push({
                name:"dzShare",
                query:{
                    isBack:"0000"
                }
            })
        }
    },
};
</script>

<style scoped>
.wrap{
    padding: 0 10px;
    padding-bottom: 20px;
}
.title{
    text-align: center;
    padding: 10px 0;
}
.weight {
  font-weight: bold;
}
p{
    line-height: 30px;
}
.subTitle{
    line-height: 28px;
    margin-top: 10px;
}
.pic{
    position: fixed;
    left: 0;
    bottom: 40%;
    opacity: .7;
}
</style>